import React, { Component } from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import Items from "../../constants/testimonials"
import Image from "gatsby-image"

export default class Slider1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nav1: null,
      nav2: null,
    }
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    })
  }
  render() {
    
    return (
      <Wrapper>
        <div className="s-container-1">
          <Slider
            className="slider2"
            asNavFor={this.state.nav1}
            ref={slider => (this.slider2 = slider)}
            lazyLoad={true}
            dots={false}
            slidesToShow={4}
            autoplay={true}
          >
            {Items.map((item, index) => {
              return (
                <div className="item-white" key={index}>
                  <h4>{item.name}</h4>
                  <div className="company">{item.company}</div>
                  <p>{item.comment.substr(0, 60)}</p>
                </div>
              )
            })}
          </Slider>
        </div>

        <div className="container2">
          <Slider
            asNavFor={this.state.nav2}
            ref={slider => (this.slider1 = slider)}
            className="slider-big"
            slidesToShow={1}
            slidesToScroll={1}
          >
            {Items.map((item, index) => {
              var next = 0
              if (index < 4) next = index + 1;
              return (
                <div key={index}>
                  <div className="item-white2">
                    <div>
                      <Image
                        className="image"
                        fluid={this.props.images[index].childImageSharp.fluid}
                        alt={item.title}
                      />
                    </div>

                    <div className="text">
                      <div className="right">
                        <h4>{item.name}</h4>
                        <p>{item.comment}</p>
                        <div className="company">{item.company}</div>
                      </div>
                      <div className="next">
                        <div className="title">{Items[next].name}</div>
                        <div className="company">{Items[next].company}</div>
                        <div className="next-review">Next review</div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: none;
  @media screen and (min-width: 1025px) {
    display: inherit;    
  }
  .item-white {
    padding: 27px 46px;
  }
  .s-container-1 {
    background-color: var(--clr-white);
  }
  f4 {
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
    }
    .company {
      font-size: 12px;
      line-height: 190%;
      color: #828282;
    }
    p {
      font-size: 14px;
      line-height: 200%;
    }
  .slider2 {
    width: 95%;
    margin: 0 auto;
    text-align: center;
    
  }

  .container2 {
    background-color: var(--clr-primary-1);
    padding: 150px;
    padding-bottom: 0px;
    display: none;
    @media screen and (min-width: 1025px) {
        display: flex;
    }
  }
  .slider-big {
    
    width: 722px;
    margin: 0 auto;
    .item-white2 {
      width: 100%;
      display: flex;
    }
    .image-area {

    }
    .image {
      transform: translate(30px -50px);
      margin-left: 41px;
      
      width: 252px;
      box-shadow: -30px 27px 1px -5px rgba(159, 157, 152, 0.8);
      

    }
    .text {  
      margin-top: 50px;
      margin-left: -210px;  
      height: 325px;
      display: flex;
      align-items: center;      
      background-color: var(--clr-white);    
      padding: 35px;
      padding-left: 245px;    
      
      position: relative;
      z-index: -1;  

      .next {
        background: var(--clr-grey-10);
        position: absolute;
        border-top: 5px solid var(--clr-primary-1);
        width: 170px;
        padding: 20px;
        text-align: center;
        left: 0;
        bottom: 0;
      }
      .next-review {
        margin-top: 10px;
        font-size: 12px;
        line-height: 190%;
      }
    }
  }
`